function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { View, Button, Divider } from "../../native";
import { useForwardRef } from "../../../hooks";
import wrapComponent from "../../../core/wrapComponent";
import { StyleSheet } from 'react-native';
import * as R from 'unitx/ramda';
import { useFormContext } from "./FormContext";

function ActionButtons({
  formContext,
  onSubmit,
  onClear,
  formData,
  defaultSubmitEnabled
}, forwardedRef) {
  const {
    mapping
  } = useFormContext(formContext);
  const [state, setState] = React.useState({
    isChanged: false,
    isReady: true
  });
  useForwardRef(forwardedRef, {}, () => ({
    onChange: (newData, __) => {
      R.ifElse(R.equals(formData), () => R.when(R.isTrue, () => setState(_objectSpread(_objectSpread({}, state), {}, {
        isChanged: false
      })))(state.isChanged), () => R.when(R.isFalse, () => {
        setState(_objectSpread(_objectSpread({}, state), {}, {
          isChanged: true
        }));
      })(state.isChanged))(newData);
    },
    onReady: isReady => {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        isReady
      }));
    }
  }));
  return /*#__PURE__*/React.createElement(View, _extends({}, mapping.fieldContainer, {
    style: [mapping.fieldContainer.style]
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(Button, _extends({}, mapping.button, {
    status: "warning",
    style: [mapping.button.style, styles.button],
    onPress: onClear,
    disabled: !state.isReady || !(state.isChanged && state.isReady)
  }), "Clear"), /*#__PURE__*/React.createElement(Button, _extends({}, mapping.button, {
    style: [mapping.button.style, styles.button],
    disabled: !state.isReady || !(state.isReady && !defaultSubmitEnabled && state.isChanged),
    onPress: onSubmit
  }), "Submit")));
}

export default wrapComponent(ActionButtons, {
  isForwardRef: true
});
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row'
  },
  button: {
    margin: 4
  }
});